import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {Panel, CheckboxWithLabel, FormError} from 'components';
import _ from 'lodash';
import {FormattedMessage} from 'react-intl';
import useModal from 'shared/hooks/useModal';
import TypeRemovalConfirmationModal from './TypeRemovalConfirmationModal';

const EmptyState = () => {
  return (
    <div className='center jumbo rounded h5 py2 px1 Table-emptyState'>
      <FormattedMessage id={'time_off.policy.edit.No time off types to display'}/>
    </div>
  );
};

const TimeOffTypes = observer(({uiState, submitStep}) => {
  const typeRemovalConfirmationModalOpen = useModal(uiState, 'TypeRemovalConfirmationModal');
  const {sortedTimeOffTypes, errors, policy, removedTypes} = uiState;

  return (
    <div>
      <Panel.Header
        title={t('time_off.policy.edit.Time Off Types')}
        description={t('time_off.policy.edit.Select the types of time off you would like made available to employees under this policy.')}
      />
      {_.isEmpty(sortedTimeOffTypes) && <EmptyState/>}
      {sortedTimeOffTypes.map((type, index) => <div className={`flex align-items-middle px1 py2 ${index === (sortedTimeOffTypes.length - 1) ? '' : 'border-bottom'}`}>
        <CheckboxWithLabel
          checked={uiState.timeOffTypeSelected(type)}
          onChange={() => uiState.toggleTimeOffType(type)}
          label={type.name}
          translatable={false}
        />
      </div>)}
      <FormError message={errors.typeIds}/>
      <TypeRemovalConfirmationModal
        isOpen={typeRemovalConfirmationModalOpen}
        onCancel={() => uiState.closeTypeRemovalConfirmationModal()}
        onSave={submitStep}
        removedTypes={removedTypes}
        policyId={policy.id}
      />
    </div>
  );
});

export default TimeOffTypes;
